// src/dayjs-jalali-setup.js
import dayjs from "dayjs";
import jalaliday from "jalaliday";
import "dayjs/locale/fa"; // Persian locale (includes month names)

// Extend dayjs with Jalali calendar plugin
dayjs.extend(jalaliday);

// Set default locale and calendar globally
dayjs.locale("fa");          // Persian months (فروردین، اردیبهشت...)
dayjs.calendar("jalali");    // Jalali/Shamsi calendar system

export default dayjs;